import React, { useContext, useEffect } from 'react';
import { AuthContext } from 'context';
// Components
import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import Heading from 'components/design-system/Heading/Heading';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import { telefonoFormato } from 'components/design-system/input/InputValidations';
// Constants
import { PERMISOS } from 'const/Permisos';
// Hooks
import { CargaUsuariosRegistrados } from 'views/Business/hooks/useServicios';
import { SelectorDireccionContainer } from 'hooks/Selectors/hooks';

export const BusinessInfo = ({
  values,
  errors,
  touched,
  onChange,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  isSubmitting
}) => {
  const { usuarios, loadUsuarios, isLoadingUsuarios } =
    CargaUsuariosRegistrados();

  useEffect(() => {
    isTienePermisos(PERMISOS.crearNegocio) && loadUsuarios();
    // console.log('usuarios ::>', usuarios);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { isTienePermisos } = useContext(AuthContext);

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-6 xxs:col-span-12 xs:col-span-12 lg:col-span-6 mb-4">
        <Heading type="h4" className="mb-0">
          Teléfono
        </Heading>
        <InputComponent
          autoComplete={'off'}
          fullWidth
          label={
            <LabelComponent esOpcional>
              Número de contacto de casa matríz
            </LabelComponent>
          }
          name="telefonoSucursal"
          onChange={event => {
            const newValue = telefonoFormato(event);
            setFieldValue('telefonoSucursal', newValue);
          }}
          onBlur={handleBlur}
          value={values.telefonoSucursal}
          placeholder="+56..."
          touched={touched.telefonoSucursal}
          estado={
            errors.telefonoSucursal
              ? { tipo: 'error', mensaje: errors.telefonoSucursal }
              : null
          }
        />
      </div>

      {/* Refactoring - direccion y mapa */}
      <SelectorDireccionContainer
        values={values}
        errors={errors}
        touched={touched}
        onChange={onChange}
        handleBlur={handleBlur}
        setFieldTouched={setFieldTouched}
        setFieldValue={setFieldValue}
        isSubmitting={isSubmitting}
        esOpcionalRegion={true}
      />

      {isTienePermisos(PERMISOS.crearNegocio) && (
        <div className="col-span-12 xs:col-span-6 lg:col-span-6">
          <AutocompleteComponent
            id="usuario"
            name="usuario"
            accesor="correoElectronico"
            options={usuarios || []}
            disabled={isLoadingUsuarios || !usuarios}
            onChange={(ev, usuario, reason) => {
              let data = { name: 'usuario', value: usuario };

              if (reason === 'clear') {
                setFieldValue('usuario', null);
              } else {
                setFieldValue('usuario', data.value);
              }
            }}
            noOptionsText="Sin opciones"
            value={values.usuario}
            getOptionLabel={option => option.correoElectronico || ''}
            // isOptionEqualToValue={(option, value) =>
            //   option.usuario === values.usuario.correoElectronico
            // }
            onBlur={() => setFieldTouched('usuario')}
          >
            <InputComponent
              autoComplete={'off'}
              fullWidth
              touched={touched.usuario ? true : false}
              estado={
                errors.usuario
                  ? { tipo: 'error', mensaje: errors.usuario }
                  : null
              }
              label={<LabelComponent>Usuario</LabelComponent>}
            />
          </AutocompleteComponent>
        </div>
      )}
    </div>
  );
};

export default BusinessInfo;
